import { useProfilePreviewData } from "PFApp/use_profile_preview";
import { Markdown } from "PFComponents/markdown";
import { useTranslation } from "react-i18next";

import { ProfilePreviewHeader } from "./profile_preview_header";

export const ProfilePreviewSummary = () => {
  const {
    data: { profile, ready }
  } = useProfilePreviewData();

  const { t } = useTranslation("profiles");

  if (!ready || !profile || !profile.summary) {
    return null;
  }

  return (
    <div data-qa-id="ProfilePreviewSummary">
      <ProfilePreviewHeader>{t("show.parts.bio")}</ProfilePreviewHeader>
      <Markdown raw={profile.summary} emojify={false} />
    </div>
  );
};
